import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

export const isNotFoundStatus = (error: FetchBaseQueryError | SerializedError | undefined) => {
    if (error && Object.hasOwn(error, "status")) {
        if ((error as FetchBaseQueryError).status === 404) {
            return true;
        }
    }
    return false;
};
